// tslint:disable:no-any (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable-next-line:no-unused-variable (autogenerated)
import 'react';
import _ from 'lodash';

interface IFormValidationResult {
    value: any;
    errors: IValidationFieldError[];
}

function processFormValidation(
    form: IFormDescriptor,
    value: any,
    oldValue: any,
    updatedFieldId?: string
): IFormValidationResult {
    let allValidationErrors: IValidationFieldError[] = [];
    const currentValue = {};
    form.fields.forEach((field: IFormFieldDescriptor) => {
        currentValue[field.id] = getFieldValue(form, field.id, value, updatedFieldId);
    });
    form.fields.forEach((field: IFormFieldDescriptor) => {
        const fieldValue = currentValue[field.id];
        if (field.validate) {
            const validationErrors = field.validate(
                fieldValue,
                oldValue ? oldValue[field.id] : undefined,
                currentValue,
                oldValue
            );
            if (validationErrors && validationErrors.length > 0) {
                validationErrors.forEach((validationError: string) => {
                    allValidationErrors.push({
                        fieldId: field.id,
                        errorMessage: validationError
                    });
                });
            }
        }
    });
    if (form.validate) {
        const result = form.validate(currentValue, oldValue);
        if (result.errors && result.errors.length > 0) {
            allValidationErrors = allValidationErrors.concat(result.errors);
        }
    }
    return { errors: allValidationErrors, value: currentValue };
}

export function getFormState(state?: IFormState): IFormState {
    const focusedFieldId = (state && state.focusedFieldId) || undefined;
    const showValidationErrorOnFields = (state && state.showValidationErrorOnFields) || {};
    const currentFieldValues = (state && state.currentFieldValues) || {};
    const storedFieldData = (state && state.storedFieldData) || {};
    const validation = (state && state.validation) || { errors: [], validated: false };
    const caretPositions = (state && state.caretPositions) || {};
    return {
        focusedFieldId,
        showValidationErrorOnFields,
        currentFieldValues,
        storedFieldData,
        caretPositions,
        validation
    };
}

function getFieldDescriptor(form: IFormDescriptor, fieldId: string): IFormFieldDescriptor {
    return _.find(form.fields, fd => fd.id === fieldId);
}

// tslint:disable-next-line:typedef (autogenerated)
function changeValueAndValidateFormOnFieldChange(
    fieldId: string,
    fieldValue: any,
    form: IFormDescriptor
) {
    const oldValue = form.value;
    const newValue = _.clone(form.value);
    const newState = getFormState(form.state);
    _.assign(newValue, newState.currentFieldValues);
    newValue[fieldId] = fieldValue;
    return processFormValidation(form, newValue, oldValue, fieldId);
}

function onAnyValueChange(
    fieldId: string,
    fieldValue: any,
    form: IFormDescriptor,
    caretPosition: number
): void {
    const oldValue = form.value;
    const field = getFieldDescriptor(form, fieldId);
    let newFieldValue = fieldValue;
    let transformed;

    if (field && field.transformValueOnChange) {
        transformed = field.transformValueOnChange(
            {
                value: fieldValue,
                data: form.state.storedFieldData[fieldId],
                caretPosition
            },
            oldValue[fieldId]
        );
        newFieldValue = transformed.value;
    }
    const { errors, value } = changeValueAndValidateFormOnFieldChange(fieldId, newFieldValue, form);
    const newState = getFormState(form.state);

    if (transformed && typeof transformed.caretPosition === 'number') {
        newState.caretPositions = newState.caretPositions || {};
        newState.caretPositions[fieldId] = transformed && transformed.caretPosition;
    }
    if (transformed && typeof transformed.data !== 'undefined') {
        newState.storedFieldData[fieldId] = transformed.data;
    }

    newState.currentFieldValues[fieldId] = newFieldValue;

    if (errors.length === 0) {
        // no errors -> clean up current values and trigger update
        _.assign(value, newState.currentFieldValues);
        newState.currentFieldValues = {};
        form.onChange(value, oldValue, fieldId);
    }
    newState.validation = { errors, validated: true };
    form.onStateChange(newState, form.state);
    // custom user handler
    if (field && field.onChange) {
        field.onChange(newFieldValue);
    }
}

function onAnyFieldFocus(fieldId: string, form: IFormDescriptor): IFormState {
    const newState = getFormState(form.state);
    newState.focusedFieldId = fieldId;
    form.onStateChange(newState, form.state);
    // custom user handler
    const field = getFieldDescriptor(form, fieldId);
    if (field && field.onFocus) {
        field.onFocus();
    }
    return newState;
}

function onAnyFieldBlur(fieldId: string, form: IFormDescriptor): void {
    const newState = getFormState(form.state);
    if (newState.focusedFieldId === fieldId) {
        newState.focusedFieldId = null;
    }
    newState.showValidationErrorOnFields[fieldId] = true;
    form.onStateChange(newState, form.state);
    // custom user handler
    const field = getFieldDescriptor(form, fieldId);
    if (field && field.onBlur) {
        field.onBlur();
    }
}

export function processInitialValidation(form: IFormDescriptor): IFormState {
    const newState = getFormState(form.state);
    const { errors } = processFormValidation(form, form.value, form.value);
    newState.validation.errors = errors;
    newState.validation.validated = true;
    if (errors.length === 0 && _.keys(newState.currentFieldValues).length > 0) {
        // no errors -> clean up current values and trigger update
        const oldValue = form.value;
        const value = _.assign(form.value, newState.currentFieldValues);
        newState.currentFieldValues = {};
        form.onChange(value, oldValue, '');
    }
    return newState;
}

export function validateOnFormSubmit(form: IFormDescriptor, value: any): boolean {
    const newState = getFormState(form.state);
    const { errors } = processFormValidation(form, value, value);
    _.forEach(form.fields, (field: IFormFieldDescriptor) => {
        newState.showValidationErrorOnFields[field.id] = true;
    });
    newState.validation.errors = errors;
    form.onStateChange(newState, form.state);
    return newState.validation.errors.length === 0;
}

// tslint:disable-next-line:typedef (autogenerated)
function getFieldValue(
    form: IFormDescriptor,
    fieldId: string,
    tmpValue?: any,
    updatedFieldId?: string
) {
    if (updatedFieldId === fieldId) {
        return tmpValue[fieldId];
    }
    const currentState = getFormState(form.state);
    return typeof currentState.currentFieldValues[fieldId] !== 'undefined'
        ? currentState.currentFieldValues[fieldId]
        : form.value[fieldId];
}

// tslint:disable-next-line:typedef (autogenerated)
function getFieldValueForDisplay(
    form: IFormDescriptor,
    fieldId: string,
    tmpValue?: any,
    updatedFieldId?: string
) {
    const value = getFieldValue(form, fieldId, tmpValue, updatedFieldId);
    const field = getFieldDescriptor(form, fieldId);
    const currentState = getFormState(form.state);
    const caretPosition = (currentState.caretPositions || {})[fieldId];
    const data = (currentState.storedFieldData || {})[fieldId];
    if (field && field.transformValueForDisplay) {
        return field.transformValueForDisplay({ value, data, caretPosition });
    }
    return { value, caretPosition, data };
}

export function getFormFieldValue<TForm>(
    form: IFormDescriptor<TForm>,
    fieldId: string
): TForm[keyof TForm] {
    return getFieldValue(form, fieldId) as TForm[keyof TForm];
}

export function clearFieldValues(formState: IFormState, fieldIds: string[]): IFormState {
    if (!formState) {
        return formState;
    }
    _.forEach(fieldIds, (fieldId: string) => {
        delete formState.caretPositions[fieldId];
        delete formState.currentFieldValues[fieldId];
        delete formState.storedFieldData[fieldId];
        delete formState.showValidationErrorOnFields[fieldId];
        delete formState.validation.errors[fieldId];
        formState.validation.validated = false;
    });
    return formState;
}

export function getPropsForField(form: IFormDescriptor, fieldId: string): IFormComponentProps {
    const currentState = getFormState(form.state);
    const { value, caretPosition, data } = getFieldValueForDisplay(form, fieldId);
    currentState.storedFieldData[fieldId] = data;
    const id = fieldId;
    const onBlur = () => onAnyFieldBlur(fieldId, form);
    const onFocus = () => onAnyFieldFocus(fieldId, form);
    const onChange = (fieldValue, currentCaretPosition) =>
        onAnyValueChange(fieldId, fieldValue, form, currentCaretPosition);
    const nullFunction = () => {};
    const field = getFieldDescriptor(form, fieldId);
    const onClick = field.onClick || nullFunction;
    const focused = currentState.focusedFieldId === fieldId;
    let validationErrorMessage = '';
    const readOnly = !!field.readOnly;
    if (currentState.showValidationErrorOnFields[fieldId]) {
        validationErrorMessage = currentState.validation.errors
            .filter(err => err.fieldId === fieldId)
            .map(err => err.errorMessage)
            .join(' ');
    }
    return {
        value,
        id,
        validationErrorMessage,
        onBlur,
        onFocus,
        onChange,
        onClick,
        focused,
        readOnly,
        caretPosition
    };
}

export interface IOption {
    value: number;
    title: string;
}

export function compareOptionsByTitle(a: IOption, b: IOption): number {
    const titleA = (a.title || '').toUpperCase();
    const titleB = (b.title || '').toUpperCase();

    if (titleA < titleB) {
        return -1;
    }

    if (titleA > titleB) {
        return 1;
    }

    return 0;
}

export function validateRequired(
    errorMsg: string,
    maxLength?: number,
    maxLengthErrorMsg?: string
): (value: string, oldValue: string) => string[] {
    return (value: string, oldValue: string) => {
        if (!value || value.length === 0) {
            return [errorMsg];
        }

        if (maxLength && value.length > maxLength) {
            return [maxLengthErrorMsg];
        }

        return [];
    };
}
